import secureLocalStorage from "react-secure-storage";
import { camelToSnake } from "../utils/camelToSnake";
import { stdObject } from "../data/types/stdObject";
import { mainConfig } from "../data/main";

export function b64EncodeUnicode(str: string) {
  // first we use encodeURIComponent to get percent-encoded Unicode,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes(_unused: string, p1: string) {
        // return String.fromCharCode(`0x${p1}`);
        return String.fromCharCode(parseInt(p1, 16));
      },
    ),
  );
}

export const sendData = async ({
  endPoint,
  payload = {},
  isToken = true,
  isBlob = false,
  logoutAction = false,
  url,
}: stdObject) => {
  let data: stdObject = { success: false, netWorkError: false };
  // let tempPayload = payload;
  try {
    url = url ?? mainConfig.url;
    if (isToken) {
      payload = { ...payload, token: secureLocalStorage.getItem("token") };
    }
    endPoint = camelToSnake(endPoint);
    const encodedPayload =
      "form" in payload
        ? payload.form
        : b64EncodeUnicode(JSON.stringify(payload));

    const serviceResponse: stdObject = { data: false };
    const headers: any = {};

    if (!("form" in payload)) {
      headers["Content-Type"] =
        "application/x-www-form-urlencoded; charset=UTF-8";
    }

    const res = await fetch(`${url}/api/${endPoint}.php`, {
      method: "POST",
      headers,
      body: encodedPayload,
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    let responseData;
    if (isBlob) {
      const blobData = await res.blob();
      responseData = { content: URL.createObjectURL(blobData) };
    } else {
      const rawText = await res.text();
      try {
        responseData = JSON.parse(rawText);
      } catch {
        responseData = { success: false, error: "invalidResponse" };
      }
    }

    serviceResponse.data = responseData;

    if (serviceResponse.data) {
      if (
        ["exit", "noAccess"].includes(serviceResponse.data.error) &&
        logoutAction
      ) {
        data.error = serviceResponse.data.error;
        logoutAction("sessionExpired");
      } else {
        data = {
          success: true,
          netWorkError: false,
          ...serviceResponse.data,
        };
      }
    }
  } catch (error: unknown) {
    console.log("error sendData:", error);
    data.netWorkError = true;
  }
  return data;
};
